// Copyright (c) 2016 Deere & Company

export const getSelectedAccounts = dealerCriteria => {

    const selectedAccounts = dealerCriteria.filter(criteria => criteria.isSelected).map(item => item.dealer);

    return selectedAccounts;

};

export const getUpdatedAccounts = (dealers, allowedAccount, isSelected) => {

    let updatedList;

    updatedList = dealers.filter(item => item.account !== allowedAccount.account);

    if (isSelected) {

        updatedList = [
            ...updatedList,
            allowedAccount
        ];

    }

    return updatedList;

};



// WEBPACK FOOTER //
// ./src/reports/shared/services/dealer-accounts.js